// extracted by mini-css-extract-plugin
export var attachment = "_mu-a";
export var emailContainer = "_mu-4";
export var emailContentPaddedContainer = "_mu-b";
export var emailHeader = "_mu-6";
export var emailIframe = "_mu-3";
export var emailInfoIcon = "_mu-9";
export var emailShortenedSummary = "_mu-e";
export var infoDropdown = "_mu-0";
export var infoRowBoundedContent = "_mu-d";
export var internal = "_mu-5";
export var merchant = "_mu-8";
export var messageInputContainer = "_mu-h";
export var normal = "_mu-7";
export var replyCard = "_mu-f";
export var subtleButton = "_mu-1";
export var subtleButtonIconContainer = "_mu-2";
export var toggleViewRepliesButton = "_mu-c";
export var wrappingText = "_mu-g";